<template>
    <div
        class="List"
    >
        <div
            v-for="(item, index) in items"
            :key="index"
            class="List-item"
        >
            <div class="List-itemContent">
                <div class="List-itemBorderContainer">
                    <slot
                        name="listItem"
                        :item="item"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.List{

    padding: 0;

    &-itemContent {
        text-align: right;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1rem;
    }

    &-itemBorderContainer{
        border-bottom: 1px solid #e6e6e6;
        width: 100%;
        padding: 1rem 0;
    }
}
</style>
